/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import Text from 'solis/react/primitive/text';


const getControl = ({ zoneTimeline, user, currentDate }) =>
{
  return zoneTimeline.getControl(user, currentDate).toFixed(1);
};


const getPreviousControl = ({ zoneTimeline, user, previousDate }) =>
{
  return zoneTimeline.getControl(user, previousDate).toFixed(1);
};


const Value = styled(Text)`
  min-width: 3.5ch;
  text-align: right;
  font-variant-numeric: tabular-nums;
`;


const Component = (props) =>
(
  <Flex align = 'center' gap = '1'>

    <Value size = '1' color = 'gray'>{getPreviousControl(props)}</Value>
    <Text.Note>→</Text.Note>
    <Value size = '1' weight = 'bold'>{getControl(props)}</Value>

  </Flex>
);


export default (props) =>
{
  return props.previousDate !== null ? <Component {...props} /> : <Value size = '1'>{getControl(props)}</Value>;
};
